import { URLSearchParams, QueryEncoder } from '@angular/http';
import { URLParams } from '../../../core/url-params.model';

export class HistoryHttpUtil {

  public static prepareParamsHistory(params): URLSearchParams {
    let urlParams = new URLParams();

    if (params.securityToken) {
      urlParams.append('securityToken', params.securityToken);
    }
    if (params.pageSize) {
      urlParams.append('pageSize', params.pageSize);
    }
    if (params.pageNumber || params.pageNumber === 0) {
      urlParams.append('pageNumber', params.pageNumber);
    }
    return urlParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/history/history.util.ts